import { LayoutRoute, Route } from "@soft-db/typed-router";

const stationsRoutes = new LayoutRoute({
	name: "stations",
	path: "stations",
	component: () => import("@/pages/stations.vue"),
	meta: {
		feature: "station",
	},
	children: [
		new Route({
			path: "",
			meta: {
				permission: "station.get",
			},
			component: () => import("@/pages/stations/index.vue"),
		}),
		new LayoutRoute({
			name: "station",
			path: ":id",
			component: () => import("@/pages/stations/_id.vue"),
			meta: {
				permission: "station.update",
			},
			children: [
				new Route({
					path: "",
					component: () => import("@/pages/stations/_id/index.vue"),
				}),
			],
		}),
	],
});

export default stationsRoutes;
